import { useEffect } from 'react';

export const observeCookiebotLongPress = () => {
  const selector = '#CookiebotWidget:not(.CookiebotWidget-open) .CookiebotWidget-logo';
  let press = null;
  let timer;
  let suppressClick = false;
  let closeButton;
  const removeCloseButton = () => {
    closeButton?.remove();
    closeButton = null;
  };
  const showCloseButton = () => {
    const widget = document.querySelector('#CookiebotWidget:not(.CookiebotWidget-open)');
    if (!widget || closeButton) return;
    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'cookiebot-launcher-dismiss';
    closeButton.setAttribute('aria-label', 'Hide cookie settings icon until refresh');
    closeButton.title = 'Hide until refresh';
    closeButton.textContent = '×';
    widget.appendChild(closeButton);
  };
  const cancel = () => {
    clearTimeout(timer);
    press = null;
  };
  const start = (event) => {
    cancel();
    suppressClick = false;
    if (!window.matchMedia('(max-width: 575px)').matches ||
        event.button !== 0 || !event.target.closest?.(selector)) return;
    press = { x: event.clientX, y: event.clientY, id: event.pointerId };
    timer = setTimeout(() => {
      suppressClick = true;
      showCloseButton();
      press = null;
    }, 650);
  };
  const move = (event) => {
    if (press && (event.pointerId !== press.id ||
        Math.hypot(event.clientX - press.x, event.clientY - press.y) > 10)) cancel();
  };
  const click = (event) => {
    if (closeButton && event.target === closeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.documentElement.setAttribute('data-cookiebot-launcher-hidden', 'true');
      removeCloseButton();
      return;
    }
    if (suppressClick && event.target.closest?.(selector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
      return;
    }
    removeCloseButton();
  };
  const contextMenu = (event) => {
    if (window.matchMedia('(max-width: 575px)').matches && event.target.closest?.(selector)) {
      event.preventDefault();
    }
  };
  const listeners = { pointerdown: start, pointermove: move, pointerup: cancel,
    pointercancel: cancel, click, contextmenu: contextMenu,
    pointerover: (event) => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
          event.target.closest?.(selector)) showCloseButton();
    },
    focusin: (event) => {
      if (event.target.closest?.(selector)) showCloseButton();
    },
    keydown: (event) => {
      if (event.key === 'Escape') removeCloseButton();
    },
  };
  Object.entries(listeners).forEach(([type, handler]) => document.addEventListener(type, handler, true));
  return () => {
    cancel();
    removeCloseButton();
    Object.entries(listeners).forEach(([type, handler]) => document.removeEventListener(type, handler, true));
    document.documentElement.removeAttribute('data-cookiebot-launcher-hidden');
  };
};

export const useCookiebotLongPress = () => useEffect(observeCookiebotLongPress, []);
